export default __webpack_public_path__ + "static/Experienced-DevOps-Company-f04f86cf4ca29abad5f93ffe227e86d6.webp";